import { Dispatcher } from './Dispatcher';
import { Constants } from './Constants';

import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';
import * as Globalization from '../../../../_common/platform/ts/Globalization';

export interface Action {
    actionType: Constants;
}

export function checkAction<T extends Action>(action: Action, id: Constants): action is T {
    return action.actionType === id;
}

export module I {
    export interface GET_GAUGE_DATA extends Action {
        config;
        id;
        cacheParams;
        theme: IValuesCollection;
        cultureValues: Globalization.ICultureValues;
    }

    export interface GET_GAUGE_DATA_FINISH extends Action {
        result;
        id;
    }
}

export class Actions {
    public gaugeGetData(
        config,
        id,
        cacheParams,
        theme: IValuesCollection,
        cultureValues: Globalization.ICultureValues
    ) {
        this.dispatcher.handleViewAction<I.GET_GAUGE_DATA>({
            actionType: Constants.GET_GAUGE_DATA,

            config: config,
            id: id,
            cacheParams,
            theme,
            cultureValues
        });
    }

    public gaugeGetDataFinish(result, id) {
        this.dispatcher.handleViewAction<I.GET_GAUGE_DATA_FINISH>({
            actionType: Constants.GET_GAUGE_DATA_FINISH,

            result: result,
            id: id
        });
    }

    constructor(private dispatcher: Dispatcher) {}

    public static get(dispatcher: Dispatcher) {
        return new Actions(dispatcher);
    }
}
